import { Badge, breakpoints, Col, Icon, Tooltip, useTheme } from "@rally/ui-kit";
import { useActivityIndicator } from "../../activity-indicator.ts";
import { say } from "../../localization/say.ts";
import { ACCOUNT_DESTINATIONS } from "../../me/destinations.ts";
import { goTo, useWhere } from "../../router.ts";

export function AccountEntries() {
  const where = useWhere();
  const theme = useTheme();
  const { many, updated } = useActivityIndicator();
  const narrow = theme.isAtMost(breakpoints.phone);
  return (
    <Col
      gap="none"
      testID="account-navigation"
      style={{ flexDirection: "row", justifyContent: "space-between" }}
    >
      {ACCOUNT_DESTINATIONS.map((entry) => {
        const selected = where.screen === "me" && where.section === entry.id;
        return (
          <Tooltip
            key={entry.id}
            below
            content={say(entry.labelKey)}
            accessibilityLabel={
              entry.id === "activity" && many > 0 ? `${say(entry.labelKey)}: ${many}` : say(entry.labelKey)
            }
            current={selected}
            onPress={() => goTo(`/me/${entry.id}`)}
            testID={`nav-${entry.id}`}
          >
            <Col
              style={{
                width: 44,
                height: 44,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: theme.radius.md,
                backgroundColor: selected ? theme.color.accentSoft : "transparent",
              }}
            >
              <Icon
                name={entry.icon}
                size={20}
                color={
                  selected || (entry.id === "activity" && (many > 0 || updated)) ? "accent" : "text.secondary"
                }
              />
              {entry.id === "activity" && many > 0 ? (
                <Col testID="activity-indicator" style={{ position: "absolute", top: 0, right: 0 }}>
                  {narrow ? (
                    <Col
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: theme.radius.round,
                        backgroundColor: theme.color.accent,
                      }}
                    />
                  ) : (
                    <Badge tone="info">{String(many)}</Badge>
                  )}
                </Col>
              ) : null}
            </Col>
          </Tooltip>
        );
      })}
    </Col>
  );
}
